import {
	ON_CLICK_DETAILS_FAIL,
	ON_CLICK_DETAILS_START,
	ON_CLICK_DETAILS_SUCCESS,
} from "../reducers/actions/ActionTypes";
import axios from "axios";
import {ON_CLICK_DETAILS_URL, SEARCH_TICKET_URL} from "./utils/ApiUrls";
import {getErrorMessage} from "../reducers/utils/ReducerUtils";
import {getConfig} from "./utils/ConfigUtils";
import {authLogout} from "./AuthServices";


export function onClickDetails(id, tipoEntita, azione, dispatch, selected) {
	dispatch({type: ON_CLICK_DETAILS_START});
	
	switch (tipoEntita) {
		case "ticket":
			if (selected) {
				axios
					.post(SEARCH_TICKET_URL, {id: id}, getConfig())
					.then((rt) => {
						let ticket = rt.data?.[0];
						if (selected.stato === ticket.stato) {
							defaultHelperCase(id, tipoEntita, azione, dispatch)
						} else {
							dispatch({
								type: ON_CLICK_DETAILS_FAIL,
								error: "Ops, il ticket selezionato è cambiato di stato, ricarico i ticket!"
							})
						}
					})
					.catch((error) => dispatch({type: ON_CLICK_DETAILS_FAIL, error: getErrorMessage(error)}))
				break;
			} else {
				defaultHelperCase(id, tipoEntita, azione, dispatch)
				break;
			}
		case "tampone":
		case "quarantena":
		default:
			defaultHelperCase(id, tipoEntita, azione, dispatch)
			break;
	}
}

function defaultHelperCase(id, tipoEntita, azione, dispatch) {
	axios
		.post(ON_CLICK_DETAILS_URL + "?id=" + id + "&tipoEntita=" + tipoEntita + "&azione=" + azione, {}, getConfig())
		.then((response) => {
			if (response.status === 226) {
				authLogout();
			} else {
				dispatch({type: ON_CLICK_DETAILS_SUCCESS, payload: response.data})
			}
		})
		.catch((error) => dispatch({type: ON_CLICK_DETAILS_FAIL, error: getErrorMessage(error)}))
}

export function resetAutomationOnClick(dispatch) {
	dispatch({type: ON_CLICK_DETAILS_START});
}
